import { all } from 'redux-saga/effects';
import authSaga from './auth/saga';
import loanSaga from './loan/saga';
import propertySaga from './property/saga';
import securitySaga from './security/saga';
import LendersSaga from './lender/saga';
import userManagementSaga from './userManagement/saga';
import notificationsSaga from './notifications/sagas';
import adminUpdatePushButtonSaga from './AdminUpdatePushButton/saga';
import ReportsSaga from './reports/saga';
import hubspotDealsSaga from './hubspot_API/saga';
import ArcherChatSaga from './archerChat/saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    loanSaga(),
    propertySaga(),
    LendersSaga(),
    securitySaga(),
userManagementSaga(),
    notificationsSaga(),
    adminUpdatePushButtonSaga(),
    ReportsSaga(),
    hubspotDealsSaga(),
    ArcherChatSaga(),
  ]);
}

//All redux saga functions need to be added to this page to be imported into the respective class
